import React from 'react';

import { IGetSubscriptionPlans } from '../../utils/types';
import Modal from '../Modal';
import { capitalize } from '../../utils/helpers';
import { SUBSCRIPTION_PLAN_CATEGORY } from '../../utils/Enums';

interface PropTypes {
  isVisible: boolean;
  onHide: () => void;
  subscriptionPlan?: IGetSubscriptionPlans;
}

const ViewSubscriptionPlan = ({
  isVisible,
  onHide,
  subscriptionPlan,
}: PropTypes) => {
  return (
    <Modal heading='Info' isVisible={isVisible} onHide={onHide}>
      <div className='w-full flex flex-col gap-4 h-full px-8'>
        <p>
          <strong>Plan name: </strong>
          {subscriptionPlan?.planName || 'N/A'}
        </p>
        <div className='flex flex-col md:flex-row justify-between gap-4 md:gap-4'>
          {subscriptionPlan?.category ===
          SUBSCRIPTION_PLAN_CATEGORY.BUSINESS_REGULAR ? (
            <p>
              <strong>Price: </strong>${subscriptionPlan?.price}
            </p>
          ) : (
            <p>
              <strong>Days: </strong>
              {subscriptionPlan?.durationDays ?? 'N/A'}
            </p>
          )}
          <p>
            <strong>Deliveries: </strong>
            {subscriptionPlan?.deliveries}
          </p>
          <p>
            <strong>Type: </strong>
            {subscriptionPlan?.planType &&
              capitalize(subscriptionPlan?.planType)}
          </p>
        </div>
        <div>
          <p>
            <strong>Description: </strong> {subscriptionPlan?.description}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default ViewSubscriptionPlan;
